<template>
	<header class="resource-planning-chart-header">
		<a
			v-if="isBookingsFeatureEnabled"
			:href="`/${Module.BOOKINGS.url}`"
			class="resource-planning-chart-header__link"
		>
			{{ $t('resource_planning_tab_header') }}
		</a>
		<h3 v-else>
			{{ $t('resource_planning_tab_header') }}
		</h3>
		<SuiInfoButton
			as="a"
			:href="WATCH_TUTORIAL_URL"
			icon="icon-play-filled-16"
		>
			{{ $t('resource_planning_watch_tutorial') }}
		</SuiInfoButton>
	</header>
</template>

<script setup lang="ts">
import { Module } from '@/constants/modules';
import { usePermissions } from '@/composables/permissions';
import { WATCH_TUTORIAL_URL } from '../../constants';
import { SuiInfoButton } from '@developers/scoro-ui';
import { computed } from 'vue';
import { Constants } from '@/constants';

const { userHas } = usePermissions();

const isBookingsFeatureEnabled = computed(() =>
	userHas(Constants.Feature.BOOKINGS)
);
</script>

<style lang="scss" scoped>
.resource-planning-chart-header {
	display: flex;
	align-items: center;
	gap: 2rem;

	&__link {
		font-size: 2rem;
		transition: color 0.2s ease;

		&:not(:hover) {
			color: $blue-50;
		}
	}
}
</style>
